import React, { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Box, Grid, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useStore from '../store/useStore';

export default function Register() {
  const navigate = useNavigate();
  const { register, loading } = useStore(); // Extraemos register y loading del store
  
  const [form, setForm] = useState({
    username: '',
    password: '',
    nombre: '',
    apellido: '',
    latitud: '',
    longitud: '',
    department: ''
  });

  const getGeoLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setForm(prev => ({
          ...prev,
          latitud: position.coords.latitude.toString(),
          longitud: position.coords.longitude.toString()
        }));
      }, (error) => {
        alert("No se pudo obtener la ubicación. Por favor, permite el acceso.");
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica de ubicación
    if (!form.latitud || !form.longitud) {
      alert("Por favor, captura tu ubicación para poder realizar entregas.");
      return;
    }

    try {
      await register(form); // Llamamos a la función del store
      alert("¡Cuenta creada con éxito! Ahora puedes iniciar sesión.");
      navigate('/login');
    } catch (error) {
      alert(error.response?.data?.message || "Error al registrar usuario");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 8 }}>
      <Paper elevation={0} sx={{ p: 4, border: '1px solid #f0f0f0', borderRadius: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 1, textAlign: 'center' }}>
          Crear Cuenta
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mb: 3, textAlign: 'center' }}>
          Únete a Stiletto SHOP para gestionar tus pedidos
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField 
                fullWidth label="Nombre" required
                value={form.nombre}
                onChange={(e) => setForm({...form, nombre: e.target.value})} 
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                fullWidth label="Apellido" required
                value={form.apellido}
                onChange={(e) => setForm({...form, apellido: e.target.value})} 
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth label="Usuario (Email o Teléfono)" required
                value={form.username}
                onChange={(e) => setForm({...form, username: e.target.value})} 
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth label="Contraseña" type="password" required
                value={form.password}
                onChange={(e) => setForm({...form, password: e.target.value})} 
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth label="Departamento (Número)" type="number" required
                value={form.department}
                onChange={(e) => setForm({...form, department: e.target.value})} 
              />
            </Grid>
            
            <Grid item xs={12}>
              <Box sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 2, border: form.latitud ? '1px solid #4caf50' : '1px solid #e0e0e0' }}>
                <Typography variant="caption" sx={{ display: 'block', mb: 1, fontWeight: 'bold' }}>
                  Ubicación para entregas
                </Typography>
                <Button 
                  size="small" 
                  variant={form.latitud ? "contained" : "outlined"} 
                  color={form.latitud ? "success" : "primary"}
                  onClick={getGeoLocation}
                  sx={{ textTransform: 'none' }}
                >
                  {form.latitud ? "Ubicación Actualizada" : "Capturar mi Ubicación"}
                </Button>
                {form.latitud && (
                  <Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#2e7d32' }}>
                    Coordenadas listas ✓
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>

          <Button 
            fullWidth variant="contained" type="submit" 
            disabled={loading}
            sx={{ 
              mt: 4, bgcolor: '#F7D060', color: '#000', 
              fontWeight: 'bold', py: 1.5, 
              '&:hover': { bgcolor: '#eec140' },
              '&:disabled': { bgcolor: '#f5f5f5' }
            }}
          >
            {loading ? 'Procesando...' : 'Finalizar Registro'}
          </Button>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Link 
              component="button"
              type="button"
              onClick={() => navigate('/login')}
              sx={{ fontSize: '14px', color: '#666', textDecoration: 'none' }}
            >
              ¿Ya tienes cuenta? Inicia sesión
            </Link>
          </Box>
        </form>
      </Paper>
    </Container>
  );
}